export const perfBreak = (name='Performance breakpoint') => {
    const breakpoint = (performance.now() / 1000).toFixed(3)
    return +breakpoint;
}